// Liens entre le Dispatch, Geotab et la Consolidation pour la même journée et le même camion.

export const LINK_CLASS = "inline-flex h-7 items-center rounded-[4px] border border-slate-300 bg-white px-2.5 text-[12.5px] font-semibold text-slate-700 hover:border-slate-400 hover:bg-slate-50 hover:text-slate-900";

export function dispatchUrl(date, period = "day", truckId = "") {
  const query = new URLSearchParams({ dispatch_date: date, dispatch_month: date.slice(0, 7) });
  if (period === "evening") query.set("dispatch_period", "evening");
  if (truckId) query.set("truck", truckId);
  query.set("detailView", "fleet");
  return `/results?${query.toString()}#fleet-view`;
}

export function consolidationUrl(date, row) {
  const query = new URLSearchParams({ view: "sheets", from_date: date, to_date: date });
  const driver = row?.driver_employee_id || row?.driver_plan;
  if (driver) query.set("select", `driver:${driver}`);
  return `/consolidation?${query.toString()}`;
}

export function geotabUrl({ date, period = "day", truckId, view = "comparison" } = {}) {
  const query = new URLSearchParams();
  if (view !== "comparison") query.set("view", view);
  if (date) query.set("date", date);
  if (period === "evening") query.set("period", "evening");
  if (truckId) query.set("truck", truckId);
  const text = query.toString();
  return text ? `/geotab?${text}` : "/geotab";
}
